const SvgTransform1 = (props) => (
  <>
    <circle cx={144.16} cy={48.05} r={47.84} fill="none" stroke={props.p50} strokeMiterlimit={10} />
    <circle cx={144} cy={48} r={48} fill="none" stroke={props.p50} strokeMiterlimit={10} />
    <path fill="none" stroke={props.p50} strokeMiterlimit={10} d="M96 48h96v96H96z" />
    <path fill="none" stroke={props.p50} strokeMiterlimit={10} d="m96 192 48-96 48 96H96z" />
    <circle cx={96} cy={48.32} r={4} fill={props.p50} />
    <circle cx={192} cy={48} r={4} fill={props.p50} />
    <circle cx={144} cy={96} r={4} fill={props.p50} />
    <circle cx={144} cy={191.9} r={4} fill={props.p50} />
    <circle cx={144.16} cy={240.05} r={47.84} fill="none" stroke={props.p50} strokeMiterlimit={10} />
    <circle cx={144} cy={240} r={48} fill="none" stroke={props.p50} strokeMiterlimit={10} />
    <path fill="none" stroke={props.p50} strokeMiterlimit={10} d="M96 240h96v96H96z" />
    <path fill="none" stroke={props.p50} strokeMiterlimit={10} d="m96 384 48-96 48 96H96z" />
    <circle cx={96} cy={240.32} r={4} fill={props.p50} />
    <circle cx={192} cy={240} r={4} fill={props.p50} />
    <circle cx={144} cy={288} r={4} fill={props.p50} />
  </>
);

export default SvgTransform1;
